import { useRef } from 'react';
import { RootState, useSelector, useDispatch } from 'src/store';
import { editPricingPopup } from 'src/store/modules/popup';

const usePopup = () => {
  const dispatch = useDispatch();
  const refPopup = useRef(null);

  let pricingPopup = useSelector(
    (state: RootState) => state.popup.pricingPopup
  );

  const openPricingPopup = () => {
    dispatch(editPricingPopup({ ...pricingPopup, isShow: true }));
  };

  const closePricingPopup = () => {
    dispatch(editPricingPopup({ ...pricingPopup, isShow: false }));
  };

  return { refPopup, openPricingPopup, closePricingPopup };
};

export default usePopup;
